import { render, staticRenderFns } from "./AllowableFeeScheduleCodesModal.vue?vue&type=template&id=4ee00a9c"
import script from "./AllowableFeeScheduleCodesModal.vue?vue&type=script&lang=js"
export * from "./AllowableFeeScheduleCodesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports